import React from 'react';
// @ts-ignore
import ReactDOM from 'react-dom';

// @ts-ignore
import { Provider } from 'react-redux';
import { store } from './store';

import App from './App';
import './App.scss';
import './index.css';

ReactDOM.render(
    <Provider store={store}>
        <App/>
    </Provider>,
    document.getElementById('root'),
);
